import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ErrorsHttpService {
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);

  public communication(error: HttpErrorResponse): void {
    console.error('ERROR HTTP', error);
    this.manageError(error);
    if (
      error &&
      error.status &&
      (error.status === 401 || error.status === 403)
    ) {
      this.router.navigate([`/auth/logout`]);
    }
  }

  public apiInvalidResponse(error: unknown): void {
    console.error('INVALID API RESPONSE', error);
    this.manageError(error);
  }

  private manageError(error: unknown): void {
    void error;
  }

  public isControlledError(error: HttpErrorResponse, code?: string): boolean {
    if (
      error?.ok === false &&
      error?.status === 400 &&
      error?.error?.errors?.length &&
      Object.prototype.hasOwnProperty.call(error?.error?.errors[0], 'code')
    ) {
      if (code) {
        return error?.error?.errors[0]?.code === code ? true : false;
      }
      return true;
    } else {
      return false;
    }
  }
}
